export const isSafari = () => {
    return /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
};